import store from '@/store'
import PouchDB from 'pouchdb-browser'

export default {
  createDatabases () {
    let username = localStorage.getItem('username')
    let localDB = new PouchDB(username)
    store.commit('setLocalDB', localDB)
    let remoteDB = new PouchDB(`${store.state.remoteUrl}/${username}`, {
      fetch: (url, opts) => fetch(url, { ...opts, credentials: 'include' }),
      skip_setup: true
    })
    store.commit('setRemoteDB', remoteDB)
  },
  async deleteDatabases () {
    await store.state.localDB.destroy()
  },
  syncDatabases () {
    store.commit('setSyncStatus', 'syncing')
    return store.state.remoteDB.sync(store.state.localDB, { live: true, retry: true })
      .on('paused', (info) => {
        store.commit('setSyncStatus', 'paused')
      }).on('active', (info) => {
        store.commit('setSyncStatus', 'syncing')
      }).on('error', (error) => {
        store.commit('setSyncStatus', 'error')
        console.log(error)
        store.commit('pushLog', 'Sync error: ' + JSON.stringify(error))
        store.commit('endLoading')
      })
  },
  async getDatabaseDocuments () {
    store.commit('startLoading')
    try {
      let result = await store.state.localDB.allDocs()
      store.commit('endLoading')
      store.commit('pushLog', 'Documents fetched')
      return result.rows
    } catch (error) {
      console.log(error)
      store.commit('endLoading')
    }
  },
  async storeDocument (document) {
    try {
      let result = await store.state.localDB.put(document)
      store.commit('pushLog', 'Doc stored')
      return result.id
    } catch (error) {
      console.log(error)
    }
  },
  async updateDocument (document) {
    try {
      let updatedDocument = await store.state.localDB.put(document)
      store.commit('pushLog', 'Updated document')
      return updatedDocument
    } catch (error) {
      console.log('Error updating document', error)
      store.commit('pushLog', error)
    }
  },
  async fetchDocument (documentId) {
    try {
      store.commit('pushLog', 'Trying to fetch the document {' + documentId + '}')
      let fetchedDocument = await store.state.localDB.get(documentId, [])
      store.commit('pushLog', 'Document fetched' + fetchedDocument.name)
      let fetchedSubdocuments = await store.state.localDB.allDocs({
        keys: fetchedDocument.subdocumentsIds,
        include_docs: true
      })
      fetchedDocument.subdocuments = fetchedSubdocuments.rows.map((subdocument) => {
        return subdocument['doc']
      })
      store.commit('pushLog', 'Sub documents fetched')
      return fetchedDocument
    } catch (error) {
      console.log(error)
      store.commit('pushLog', error)
    }
  },
  async uploadAttachment (documentId, name, documentRevision, blob, type) {
    try {
      store.commit('pushLog', 'Uploading attachment')
      return await store.state.localDB.putAttachment(documentId, name, documentRevision, blob, type)
    } catch (error) {
      console.log('Error uploading attachment', error)
      store.commit('pushLog', error)
    }
  },
  async getAttachment (documentId, attachmentId) {
    try {
      store.commit('pushLog', 'Getting attachment: ' + attachmentId)
      let attachment = await store.state.localDB.getAttachment(documentId, attachmentId)
      store.commit('pushLog', 'Attachment fetched')
      return attachment
    } catch (error) {
      console.log('Error getting attachment', error)
      store.commit('pushLog', error)
    }
  },
  async deleteAttachment (documentId, attachmentId, documentRevision) {
    try {
      store.commit('pushLog', 'Deleting attachment: ' + attachmentId)
      let attachment = await store.state.localDB.removeAttachment(documentId, attachmentId, documentRevision)
      store.commit('pushLog', 'Attachment deleted')
      return attachment
    } catch (error) {
      console.log('Error deleting attachment', error)
      store.commit('pushLog', error)
    }
  },
  async deleteDocument (documentId) {
    try {
      let documentToDelete = await this.fetchDocument(documentId)
      let deletedResponse = await store.state.localDB.remove(documentToDelete)
      store.commit('pushLog', 'Deleted document')
      return deletedResponse
    } catch (error) {
      console.log('Error updating document', error)
      store.commit('pushLog', error)
    }
  }
}
